/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: "Corridor" | "Kitchen" | "Office" | "Room" | "Toilet" }} Room_Type_AbbreviationInputs */



/**
* | type | output |
* | --- | --- |
* | "Corridor" | "DGT" |
* | "Kitchen" | "CUIS" |
* | "Office" | "BUR" |
* | "Room" | "CH" |
* | "Toilet" | "WC" |
*
* @param {Room_Type_AbbreviationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_type_abbreviation = /** @type {((inputs: Room_Type_AbbreviationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Type_AbbreviationInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.type === "Corridor") return /** @type {LocalizedString} */ (`DGT`);
		if (i?.type === "Kitchen") return /** @type {LocalizedString} */ (`CUIS`);
		if (i?.type === "Office") return /** @type {LocalizedString} */ (`BUR`);
		if (i?.type === "Room") return /** @type {LocalizedString} */ (`CH`);
		if (i?.type === "Toilet") return /** @type {LocalizedString} */ (`WC`);
		return /** @type {LocalizedString} */ ("room_type_abbreviation");
	}
	{
		if (i?.type === "Corridor") return /** @type {LocalizedString} */ (`DGT`);
		if (i?.type === "Kitchen") return /** @type {LocalizedString} */ (`CUIS`);
		if (i?.type === "Office") return /** @type {LocalizedString} */ (`BUR`);
		if (i?.type === "Room") return /** @type {LocalizedString} */ (`CH`);
		if (i?.type === "Toilet") return /** @type {LocalizedString} */ (`WC`);
		return /** @type {LocalizedString} */ ("room_type_abbreviation");
	}
});